module.exports = __webpack_public_path__ + "media/images/admin/icons/save-7594d350dc632274f80b9aae9e3c07f0.svg";